import { InviteFragment } from 'src/graphql/fragments/__generated__/InviteFragment'
import Action from '../action'
import { createdInvite } from '../actions/invites'

type State = {
  invite?: InviteFragment
}

export default (state: State = {}, action: Action): State => {
  switch (action.type) {
    case createdInvite.type:
      return { ...state, invite: action.invite }
    default:
      return state
  }
}
